import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withPropsOnChange from 'recompose/withPropsOnChange';
import pure from 'recompose/pure';
import { spring } from 'react-motion';

export const ClustermarkerHOC = compose(
  defaultProps({
    damping: 7,
    defaultScale: 1,
    hovered: false,
    hoveredScale: 1.15,
    initialScale: 0.6,
    precision: 0.001,
    stiffness: 320,
    text: '0',
  }),
  pure,
  withPropsOnChange(
    ['initialScale'],
    ({
      initialScale, defaultScale, $prerender,
    }) => ({
      defaultMotionStyle: {
        scale: $prerender ? defaultScale : initialScale,
      },
      initialScale,
    }),
  ),
  withPropsOnChange(
    ['hovered'],
    ({
      hovered, hoveredScale, defaultScale,
      stiffness, damping, precision,
    }) => ({
      hovered,
      motionStyle: {
        scale: spring(
          hovered ? hoveredScale : defaultScale,
          {
            damping,
            precision,
            stiffness,
          },
        ),
      },
    }),
  ),
);
